// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"PriceTrackerSignUpLayout-mobile__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/layouts/PriceTrackerSignUpLayout/PriceTrackerSignUpLayout.mobile.scss
 ** module id = 957
 ** module chunks = 1
 **/